// extracted by mini-css-extract-plugin
export default {"preview":"image-preview_preview__xM-Pe","info":"image-preview_info__hKNbk","image":"image-preview_image__tMb7G","zoomed":"image-preview_zoomed__Sn8lj"};